type InstallPromptEvent = Event & { prompt: () => Promise<void>; userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }> }

let deferred: InstallPromptEvent | null = null
const key = 'lr-discovery-install-dismissed'

function isStandalone() {
  return window.matchMedia('(display-mode: standalone)').matches || Boolean((navigator as Navigator & { standalone?: boolean }).standalone)
}

function requestedFromHub() {
  return new URLSearchParams(window.location.search).get('install') === '1'
}

window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault()
  deferred = event as InstallPromptEvent
  if (localStorage.getItem(key) === '1' || isStandalone()) return
  render()
})

window.addEventListener('appinstalled', () => {
  deferred = null
  document.querySelector('[data-lr-install]')?.remove()
  localStorage.removeItem(key)
})

function render() {
  if (document.querySelector('[data-lr-install]') || isStandalone()) return
  const es = document.documentElement.lang !== 'en'
  const fromHub = requestedFromHub()
  const card = document.createElement('aside')
  card.dataset.lrInstall = 'true'
  card.className = `lr-install-card${fromHub ? ' lr-install-card--hub' : ''}`
  card.setAttribute('aria-label', es ? 'Instalar Directorio' : 'Install Directory')
  card.innerHTML = `<button class="lr-install-close" aria-label="${es ? 'Cerrar' : 'Close'}">×</button><img src="/brand-mark.svg" alt=""><div><strong>${es ? 'Instala el Directorio' : 'Install the Directory'}</strong><p>${es ? 'Ten Los Recomendados a mano para descubrir lugares más rápido.' : 'Keep Los Recomendados ready to discover places faster.'}</p><button class="lr-install-button">${es ? 'Instalar app' : 'Install app'}</button></div>`
  card.querySelector('.lr-install-close')?.addEventListener('click', () => { localStorage.setItem(key, '1'); card.remove() })
  card.querySelector('.lr-install-button')?.addEventListener('click', async () => {
    if (!deferred) return
    await deferred.prompt()
    const choice = await deferred.userChoice
    if (choice.outcome === 'accepted') { deferred = null; card.remove() }
  })
  document.body.appendChild(card)
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js').catch(() => {}))
}
